import { Testimonio as c } from "../EditPanel/Testimonio";
import { conLanding } from "../Models/Landing";

export default class Testimonio extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}